import PropTypes from 'prop-types';
import React from 'react';
import { BoxMessage, MESSAGE_TYPE } from '@components/Messages';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import usePrevious from '@hooks/usePrevious';
import { TOAST_STATE } from '@shared/constants';
import Container from '@shared/containers/Toast/components/Container';

const toastColorToBoxMessageTypeMap = {
  [TOAST_STATE.SUCCESS]: MESSAGE_TYPE.POSITIVE,
  [TOAST_STATE.ERROR]: MESSAGE_TYPE.NEGATIVE,
  [TOAST_STATE.NEUTRAL]: MESSAGE_TYPE.INFO,
};

function Toast({ title, hideToast, color, show }) {
  const isDesktop = useIsDesktopLayout();
  const type = toastColorToBoxMessageTypeMap[color] ?? MESSAGE_TYPE.POSITIVE;
  // save previous state, in order to avoid switching to another type and empty
  // title when toast disappears
  const previousTitle = usePrevious(title) || '';
  const previousType = usePrevious(type);

  return (
    <Container isDesktop={isDesktop} show={show}>
      <BoxMessage
        type={show ? type : previousType}
        title={show ? title : previousTitle}
        onClose={hideToast}
      />
    </Container>
  );
}

Toast.propTypes = {
  title: PropTypes.string.isRequired,
  hideToast: PropTypes.func.isRequired,
  color: PropTypes.oneOf(Object.values(TOAST_STATE)),
  show: PropTypes.bool.isRequired,
};

Toast.defaultProps = {
  color: TOAST_STATE.SUCCESS,
};

export default Toast;
